import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import { closeModal, modalType } from '../../actions'
import ContactFormContainer from '../../pages/contact/edit/edit.container'
import GDPRWarningModal from '../../pages/contact/edit/form/components/gdpr/warning.component'

const globalModals = {
  [modalType.CONTACT_FORM]: ContactFormContainer,
  [modalType.GDPR_WARNING]: GDPRWarningModal
}

/**
 * Modal Provider Component
 */
const ModalProvider = ({ modals, closeModal }) => {
  return (modals || [])
    .filter((modal) => modal && (modal.type || modal.component))
    .map((modal, index) => {
      const ModalComponent = (!modal.component && modal.type) ? globalModals[modal.type] : modal.component
      const props = modal.props || {}
      return (
        <ModalComponent
          {...props}
          key={`modal--${index}`}
          onClose={(params) => {
            props.onClose && props.onClose(params)
            closeModal()
          }}
        />
      )
    })
}

ModalProvider.propTypes = {
  /**
   * Array of modals to render
   */
  modals: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Modal Type
     */
    type: PropTypes.oneOf(Object.keys(globalModals)),

    /**
     * Modal Inner Component
     */
    component: PropTypes.func,

    /**
     * Modal Inner Component Props
     */
    props: PropTypes.shape({

      /**
       * Used as a callback function to lift the state up to parent component
       */
      onClose: PropTypes.func
    })
  }))
}

const mapStateToProps = (state) => ({
  modals: state.modal.modals || []
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: bindActionCreators(closeModal, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalProvider))